<template>
  <div id="content-popup">
    <div class="popup-detail">
      <div class="box-detail">
        <div class="popup-image">
          <div class="report">Report</div>
          <div class="images-popup" :style="{'background-image':'url('+data.image+')'}"></div>
        </div>
        <div class="popup-description">
          <span class="close" @click="close">CLOSE</span>
          <div class="title">
            Image approval
            <svg xmlns="http://www.w3.org/2000/svg" width="17.191" height="17.191" viewBox="0 0 17.191 17.191">
              <g id="Group_378" data-name="Group 378" transform="translate(-163.838 -159.703)">
                <g id="Group_351" data-name="Group 351" transform="translate(163.838 159.703)">
                  <path id="Path_313" data-name="Path 313" d="M172.434,176.894a8.6,8.6,0,1,1,8.6-8.6A8.605,8.605,0,0,1,172.434,176.894Zm0-16.335a7.74,7.74,0,1,0,7.74,7.74A7.748,7.748,0,0,0,172.434,160.559Z" transform="translate(-163.838 -159.703)" fill="#b9b9b9"/>
                </g>
                <g id="Group_352" data-name="Group 352" transform="translate(169.659 164.02)">
                  <path id="Path_314" data-name="Path 314" d="M192.8,185.581a3.658,3.658,0,0,1,.185-1.294,2.024,2.024,0,0,1,.6-.823,4,4,0,0,0,.632-.638,1.041,1.041,0,0,0,.216-.637q0-.848-.73-.848a.677.677,0,0,0-.545.247,1.051,1.051,0,0,0-.219.668h-1.9a2.264,2.264,0,0,1,.708-1.749,2.82,2.82,0,0,1,1.954-.626,2.93,2.93,0,0,1,1.94.579,2.03,2.03,0,0,1,.688,1.645,1.918,1.918,0,0,1-.185.848,2.869,2.869,0,0,1-.6.781l-.646.6a1.522,1.522,0,0,0-.382.542,2.147,2.147,0,0,0-.118.7Zm-.23,1.708a.872.872,0,0,1,.3-.682,1.187,1.187,0,0,1,1.5,0,.925.925,0,0,1,0,1.365,1.187,1.187,0,0,1-1.5,0A.871.871,0,0,1,192.573,187.289Z" transform="translate(-191.045 -179.881)" fill="#b9b9b9"/>
                </g>
              </g>
            </svg>
          </div>
          <div class="poster-name">
            <img src="" alt="" width="43px" height="43px">
            <div>
              <span class="name">Poster-name</span><br>
              <span class="date-post">Posted 3m ago</span>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
              <g id="Group_4005" data-name="Group 4005" transform="translate(539.421 -167.047)">
                <path id="Path_11396" data-name="Path 11396" d="M-520.345,171.648a1.47,1.47,0,0,0-1.47,1.47,1.47,1.47,0,0,0,1.47,1.47,1.47,1.47,0,0,0,1.47-1.47A1.47,1.47,0,0,0-520.345,171.648Zm-6.534,1.885a6.181,6.181,0,0,0-6.174,6.174,6.181,6.181,0,0,0,6.174,6.174,6.181,6.181,0,0,0,6.174-6.174A6.181,6.181,0,0,0-526.879,173.533Zm0,10.129a3.959,3.959,0,0,1-3.955-3.955,3.959,3.959,0,0,1,3.955-3.955,3.959,3.959,0,0,1,3.955,3.955A3.959,3.959,0,0,1-526.879,183.662Zm12.458-9.086a7.53,7.53,0,0,0-7.531-7.53h-9.939a7.53,7.53,0,0,0-7.531,7.53v9.94a7.531,7.531,0,0,0,7.531,7.53h9.939a7.53,7.53,0,0,0,7.531-7.53Zm-2.359,9.94a5.172,5.172,0,0,1-5.172,5.172h-9.939a5.172,5.172,0,0,1-5.172-5.172v-9.94a5.172,5.172,0,0,1,5.172-5.172h9.939a5.172,5.172,0,0,1,5.172,5.172Z" fill="#58595b"/>
              </g>
            </svg>
          </div>
          <div class="description">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi interdum est nec volutpat facilisis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aliquam efficitur luctus leo, ac imperdiet est vulputate ut. Nunc at nisi ut nisi scelerisque hendrerit. Cras euismod viverra lacus, at volutpat enim ultricies ac. Donec eu porta lectus, vitae laoreet magna. Nulla malesuada ipsum nec varius egestas. Mauris scelerisque mollis tortor eget sodales. Cras metus nisl, posuere nec sodales eget, blandit vel nisi. Donec imperdiet venenatis mi sed ultricies. Vivamus vehicula turpis sed mi feugiat, at pulvinar nisi congue. Ut ante ante, bibendum non massa sed, porttitor aliquet neque.
          </div>
          <div class="button">
            <button class="btn-approve">
              <svg xmlns="http://www.w3.org/2000/svg" width="30.222" height="27.901" viewBox="0 0 30.222 27.901">
                <path id="iconfinder_icon-checkmark-round_211643" d="M77.028,64.588a2.705,2.705,0,0,0-3.93.661L60.029,84.369l-7.2-7.795a2.69,2.69,0,0,0-3.974-.131,3.111,3.111,0,0,0-.123,4.221s8.746,9.705,10,10.679a2.705,2.705,0,0,0,3.93-.661L77.653,68.765A3.111,3.111,0,0,0,77.028,64.588Z" transform="translate(-47.968 -64.015)" fill="#fff"/>
              </svg>
              Show this content
            </button>
            <button class="btn-disapprove">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.995" height="29.995" viewBox="0 0 29.995 29.995">
                <path id="iconfinder_icon-close-round_211651" d="M93.095,89.12l-10.2-10.2,10.2-10.2a2.81,2.81,0,0,0-3.974-3.974l-10.2,10.2-10.2-10.2a2.81,2.81,0,0,0-3.974,3.974l10.2,10.2-10.2,10.2a2.81,2.81,0,0,0,3.974,3.974l10.2-10.2,10.2,10.2a2.81,2.81,0,0,0,3.974-3.974Z" transform="translate(-63.925 -63.925)" fill="#fff"/>
              </svg>
              Hide on all my boards
            </button>
          </div>
        </div>
      </div>
      <div class="arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="71.439" height="71.439" viewBox="0 0 71.439 71.439" class="arrow-left">
          <path id="Path_158" data-name="Path 158" d="M14.04,14.04,50.271,0,0,50.759Z" transform="translate(0 35.547) rotate(-45)" fill="#b9b9b9"/>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" width="71.439" height="71.439" viewBox="0 0 71.439 71.439" class="arrow-right">
          <path id="Path_21" data-name="Path 21" d="M14.04,14.04,50.271,0,0,50.759Z" transform="translate(71.439 35.892) rotate(135)" fill="#b9b9b9"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'content-popup',
  props:{
    data : {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
  #content-popup {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(0,0,0,.7);

    .popup-detail {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 60vh;
      width: 72%;
      background-color: #FFF;
      

      .box-detail {
        width: 100%;
        height: 100%;
        display: flex;
        padding: 10px 40px;

        .popup-image {
          width: 40%;

          .report {
            padding: 20px 0;
            width: 100%;
            color: #C53F3F;
            font-size: 14px;
            font-weight: lighter;
          }

          .images-popup {
            width: 100%;
            height: 70.4%;
            background-position: center;
            background-size: cover;
          }
        }

        .popup-description {
          position: relative;
          width: 60%;
          padding: 0 10px;

          .close {
            cursor: pointer;
            position: absolute;
            top: 0px;
            right: -30px;
            font-size: 12px;
            font-weight: lighter;
            color: #B9B9B9;
          }

          .title {
            color: var(--primary-color);
            font-size: 24px;
            font-weight: bold;
          }

          .poster-name {
            display: flex;
            position: relative;

            .name {
              color: #58595B;
              font-size: 14px;
              font-weight: bold;
            }

            .date-post {
              color: #B9B9B9;
              font-size: 14px;
              font-weight: lighter;
            }

            svg {
              position: absolute;
              right: 5px;
            }
          }

          .description {
            color: #58595B;
            font-size: 14px;
            font-weight: lighter;
            margin-bottom: 10px;
          }
        }

        .button {
          .btn-approve {
            height: 50px;
            color: #FFF;
            background-color: var(--primary-color);
            border: 0;
            padding-left: 20px;
            padding-right: 20px;
          }

          .btn-disapprove {
            height: 50px;
            color: #FFF;
            background-color: #58595B;
            border: 0;
            padding-left: 20px;
            padding-right: 20px;
          }
        }
      }

      

      .arrow {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        .arrow-left {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }

        .arrow-right {
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
    }
  }
</style>


